import { render, staticRenderFns } from "./HotelView.vue?vue&type=template&id=2913d34e&scoped=true&"
import script from "./HotelView.vue?vue&type=script&lang=js&"
export * from "./HotelView.vue?vue&type=script&lang=js&"
import style0 from "./HotelView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HotelView.vue?vue&type=style&index=1&id=2913d34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2913d34e",
  null
  
)

export default component.exports